// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1971) return "static/chunks/02d30405-5eeadedc11285f81.js";
	if (chunkId === 8594) return "static/chunks/8594-974e0c0d867b5f07.js";
	if (chunkId === 7581) return "static/chunks/7581-61361b657afd41d2.js";
	if (chunkId === 8137) return "static/chunks/8137-513a94ad60f9b221.js";
	if (chunkId === 3405) return "static/chunks/3405-0fa7ec0168ffc9f0.js";
	if (chunkId === 2943) return "static/chunks/2943-6468e0e7053a4c9c.js";
	if (chunkId === 777) return "static/chunks/777-3b780812cd38c99e.js";
	if (chunkId === 3156) return "static/chunks/3156-f3ee71cac87f7859.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"54":"1b34c61698aab779","804":"792193c2d0a8497d","1117":"cfc7bd1056d07478","1673":"0bb5c6c8741eaf80","2140":"c4b9d5fc8ea1adc5","4686":"115275b932ae91d1","5836":"b1bbb1844db0f95e","9074":"b4f3a6dec25db430","9249":"64e9775df8e4fa7e"}[chunkId] + ".js";
};